import { jsxs as d, jsx as t } from "react/jsx-runtime";
import L from "classnames";
import { forwardRef as R } from "react";
import s from "./index.es723.js";
import { MoreInfo as h } from "./index.es159.js";
import { HelpButton as f } from "./index.es10.js";
import { FeedbackMessage as j } from "./index.es46.js";
import { BodyText as N } from "./index.es505.js";
const D = R(
  ({
    disabled: m,
    label: r,
    required: e,
    feedback: i,
    children: v,
    asterix: o,
    isError: n,
    testId: p,
    variant: u = "regular",
    infoTooltip: a,
    additionalHelp: l,
    id: y,
    ...z
  }, g) => {
    const w = L(s.topLabels, {
      [s.asterix]: o && !!r
    }), C = !!(i != null && i.length), c = o && r;
    return /* @__PURE__ */ d(
      "div",
      {
        className: s.wrapper,
        "data-testid": p,
        ref: g,
        ...z,
        "data-disabled": m,
        "data-required": e,
        "data-asterix": o,
        "data-is-error": n,
        "data-info-tooltip": a,
        children: [
          (r || e || o) && /* @__PURE__ */ d("div", { className: w, children: [
            /* @__PURE__ */ d("div", { className: s.labelHolder, children: [
              /* @__PURE__ */ t(
                N,
                {
                  testId: `${p}-label`,
                  size: "small",
                  variant: u,
                  color: "secondary",
                  children: r
                }
              ),
              a && !o && r && /* @__PURE__ */ t(
                h,
                {
                  tooltip: a,
                  "data-pl-identifier": "info-tooltip",
                  "data-testid": "info-tooltip"
                }
              ),
              l && !o && r && /* @__PURE__ */ t("div", { className: s.additionalHelpContainer, children: /* @__PURE__ */ t(f, { size: "small", ...l }) })
            ] }),
            (e || o) && !m && /* @__PURE__ */ t(
              N,
              {
                size: "small",
                color: c && !e && !n ? "primary-brand" : "error",
                children: c ? "*" : "Required"
              }
            ),
            l && o && /* @__PURE__ */ t("div", { className: s.additionalHelpContainer, children: /* @__PURE__ */ t(f, { size: "small", ...l }) }),
            a && o && r && !m && /* @__PURE__ */ t(
              h,
              {
                tooltip: a,
                "data-pl-identifier": "info-tooltip",
                "data-testid": "info-tooltip"
              }
            )
          ] }),
          v,
          C && i && /* @__PURE__ */ t(j, { feedback: i, id: y })
        ]
      }
    );
  }
);
export {
  D as LabeledField
};
//# sourceMappingURL=index.es512.js.map
